module.exports = __webpack_public_path__ + "static/media/rootstock.79168d5e.svg";